export default function HeroVideo({ src = "/videos/hero.mp4" }) {
  const isVideo = /\.(mp4|webm|mov)$/i.test(src);

  if (isVideo) {
    return (
      <div className="overflow-hidden rounded-2xl">
        <video
          src={src}
          autoPlay
          muted
          loop
          playsInline
          preload="metadata"
          className="h-auto w-full"
        />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt="Shadow in action — completing to-dos during a live call"
      className="h-auto w-full select-none rounded-2xl"
      draggable="false"
    />
  );
}
